import Vue from 'vue';
import Vuex from 'vuex';
import pathify from '@/plugins/vuex-pathify';
import modules from "./modules";
import enviroment from '@/assets/js/environment';
import pkg from '@/../package.json';
Vue.use(Vuex);
export default new Vuex.Store({
  modules: modules,
  plugins: [pathify.plugin],
  state: {
    app: {
      /** A versão do app. */
      version: pkg.version,
      /** Configurações globais do app. */
      sync: {
        /** Janela em minutos usada para decidir quando uma sincronização deve ser disparada novamente. */
        contratoRefreshMinutes: 30
      }
    },
    /** Ambiente da aplicação. */
    enviroment: enviroment
  }
});